import {bindActionCreators} from 'redux';
import {ActionCreators} from 'redux-undo';
import {createStructuredSelector} from 'reselect';
// selectors
import {
  getAnchorStyle,
  getProductViews,
  getErrorFreeSelectedProduct,
  getSelectedProductColor,
  getSelectedView,
  getSelectedViewGuidelines,
  getSimilarProductWithImages,
  getViewConstraint,
  hasSleeveProductImageIssue,
  hasOverlay,
  isSelectedProductEmbroidered
} from '~/selectors/ProductSelectors';
import {
  disabledCanvas as disabled,
  getIconsArray,
  getSelectedIconIds,
  getSelectedIconType,
  hasClipping,
  hasSleeveDesign,
  isBlank,
  selectedIconId,
  selectedViewId,
  sleevePrintEnabled
} from '~/selectors/CanvasSelectors';
import {getIntersectingIcons} from '~/selectors/IconButtonsSelectors';
import {selectIsCurrentDesignInCart} from '~/slices/cartSlice';
import {isFetching, getCurrentDesignName} from '~/selectors/DesignSelectors';
import {redoable, undoable} from '~/selectors/IconSelectors';
import {blurCanvas, contextualToolsOpen} from '~/selectors/MenuSelectors';
import {prompt} from '~/actions/NotificationActions';
import {
  isSleeveDecoEligible,
  isMultiItemEligible
} from '~/selectors/ConfigSelectors';
// actions
import * as CanvasActions from '~/actions/CanvasActions';
import * as CatalogActions from '~/actions/CatalogActions';
import * as IconActions from '~/actions/IconActions';
import * as IconButtonsActions from '~/actions/IconButtonsActions';
import * as ProductActions from '~/actions/ProductActions';
import {uploadOrBrowseArt, zoomIn, zoomOut} from '~/actions/AnalyticsActions';
import {
  deselectAllIcons,
  selectIcon,
  selectIcons
} from '~/actions/SelectionActions';
import {
  updateFontHeight,
  repositionForTextEffects
} from '~/actions/TextActions';

export function select() {
  return createStructuredSelector({
    blankDesign: isBlank,
    blur: blurCanvas,
    contextualToolsOpen,
    designName: getCurrentDesignName,
    disabled,
    fetchingDesign: isFetching,
    anchorProduct: getAnchorStyle,
    getProductViews,
    getViewConstraint,
    guidelines: getSelectedViewGuidelines,
    hasClipping,
    hasSleeveProductImageIssue,
    hasOverlay,
    hasSleeveDesign,
    icons: getIconsArray,
    isCurrentDesignInCart: selectIsCurrentDesignInCart,
    isEmbroidered: isSelectedProductEmbroidered,
    isMultiItemEligible,
    isSleeveDecoEligible,
    product: getErrorFreeSelectedProduct,
    productColor: getSelectedProductColor,
    redoable,
    intersectingIcons: getIntersectingIcons,
    selectedIconId,
    selectedIconIds: getSelectedIconIds,
    selectedIconType: getSelectedIconType,
    selectedView: getSelectedView,
    selectedViewId: selectedViewId,
    similarProductWithImages: getSimilarProductWithImages,
    sleevePrintEnabled,
    undoable
  });
}

export function actions(dispatch) {
  const actions = {
    ...bindActionCreators(CatalogActions, dispatch),
    ...bindActionCreators(ProductActions, dispatch),
    ...bindActionCreators(CanvasActions, dispatch),
    ...bindActionCreators(IconActions, dispatch),
    ...bindActionCreators(IconButtonsActions, dispatch),
    ...bindActionCreators(ActionCreators, dispatch),
    deselectAllIcons: bindActionCreators(deselectAllIcons, dispatch),
    prompt: bindActionCreators(prompt, dispatch),
    repositionForTextEffects: bindActionCreators(
      repositionForTextEffects,
      dispatch
    ),
    selectIcon: bindActionCreators(selectIcon, dispatch),
    selectIcons: bindActionCreators(selectIcons, dispatch),
    zoomIn: bindActionCreators(zoomIn, dispatch),
    zoomOut: bindActionCreators(zoomOut, dispatch),
    updateFontHeight: bindActionCreators(updateFontHeight, dispatch),
    uploadOrBrowseArt: bindActionCreators(uploadOrBrowseArt, dispatch)
  };
  return () => actions;
}
